<ion-content>
  
    <ion-toolbar>
      <div class="btn-back-menu" (click)="onBackMenu()">
        <button ion-button clear color="light" no-padding>
          <ion-icon large name="arrow-back" style="font-size: 26px;padding-right: 3px;color:#294F94"></ion-icon>
              <!-- <strong style="color:#294F94 !important" class="margin-sides">{{ 'GLOBAL_CANCEL' | translate}}</strong> -->
              <p style="color:#294F94; font-size: 16px;" class="margin-sides">Zurück</p>
        </button>
    </div>
        <ion-title class="title">Add athlete</ion-title>
    </ion-toolbar>
    <ion-list>
      <div class="background-container">
          <div shape="round" class="user-avatar">
              <ion-icon color="white" style="font-size: 40px;"name="camera"></ion-icon>   
          </div>
      </div>
      
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete firstname</ion-label>
          <ion-input
            type="text"
            large
            placeholder="{{athleteData.firstName}}"
            [(ngModel)]="athleteData.firstName"
          ></ion-input>
        </ion-item>
        <ion-item class="w-100">
          <ion-label fixed class="data-label">Athlete surname</ion-label>
        <ion-input
          type="text"
          large
          placeholder="{{athleteData.lastName}}"
          [(ngModel)]="athleteData.lastName"
        ></ion-input>
      </ion-item>
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete bib number</ion-label>
          <ion-input
            type="text"
            large
            placeholder="{{athleteData.bibNo}}"
            [(ngModel)]="athleteData.bibNo"
          ></ion-input>
        </ion-item>
        <ion-item class="w-100">
            <ion-label fixed class="data-label">Athlete time</ion-label>
          <!-- <ion-input
          type="time" step="1"
            large
            placeholder="{{athleteData.time}}"
            [(ngModel)]="athleteData.time"
          ></ion-input> -->
          
            <!-- <ion-datetime style="display: flex;align-items: center; background-color: rgb(243,243,243); width: 100%" [hourValues] = "hourValues" [minuteValues] = "minuteValues" displayFormat="HH:mm:ss" [(ngModel)]="athleteData.time"></ion-datetime> -->
            <ion-datetime
              presentation="time"
              [hourValues]="hourValues"
              [minuteValues]="minuteValues"
              [(ngModel)]="timeWithoutSeconds"
              (ionChange)="updateTime()">
            </ion-datetime>

            <ion-select
              interface="popover"
              [(ngModel)]="seconds"
              (ionChange)="updateTime()">
              <ion-select-option *ngFor="let s of secondsList" [value]="s">
                {{ s < 10 ? '0'+s : s }}
              </ion-select-option>
            </ion-select>
  
          </ion-item>
      </ion-list>
      <div class="button-container">
        <button center ion-button (click)="addNewAthlete()">Add athlete</button>
      </div>
        
</ion-content>
